
export const transformFileLocationUtil = (toTransformData, key) => {
    if (toTransformData && toTransformData.fileLocation) {
        toTransformData.uploadFiles = { [key]: toTransformData.fileLocation}
        delete toTransformData.fileLocation;
        // delete toTransformData[key];
    }
    return toTransformData;
}
